import React from "react"
import { parseSessionIsoDateForDisplay } from "../../../utils/dates";
import { ucFirst } from "../../../utils/strings";

function ConfirmationTicketsInfo({data}) {
    const date = parseSessionIsoDateForDisplay(data.session.timestamp);
    const seatsString = data.seats ? data.seats.join('-') : '';

    return <React.Fragment>
        <div className="confirmation-info-block">
            <p className="confirmation-info-row">
                <span className="confirmation-info-label">Fecha</span>
                {ucFirst(date.format('dddd DD [de] MMMM'))}
            </p>
            <p className="confirmation-info-row">
                <span className="confirmation-info-label">Hora</span>
                {date.format('hh:mm A')}
            </p>
            <p className="confirmation-info-row">
                <span className="confirmation-info-label">Sala</span>
                {data.auditorium_number}
            </p>
            {seatsString && (
                <p className="confirmation-info-row">
                    <span className="confirmation-info-label">Asientos</span>
                    {seatsString}
                </p>
            )}
            {data.movie.label && <p className="confirmation-info-row">
                <span className="confirmation-info-label">formato</span>
                {data.movie.label}
            </p>}
            <p className="confirmation-info-row">
                <span className="confirmation-info-label">Boletos</span>
                {data.tickets.map(ticket => ticket.qty + ' ' + ticket.name).join(' + ')}
            </p>
        </div>
    </React.Fragment>;
}

export default ConfirmationTicketsInfo;